import { ReactNode } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, useTheme } from '@mui/material';

import { Skeleton, Typography } from '@zendesk/forethought-elements';
import { NA } from '../constants';

export const InlineData = ({
  color,
  isLoading = false,
  label,
  value = NA,
}: {
  color?: string;
  isLoading?: boolean;
  label: string;
  value?: string | number | ReactNode;
}) => {
  const { t } = useTranslation('intent-conversation-analytics');
  const { palette } = useTheme();

  if (React.isValidElement(value)) {
    return (
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <Typography color={palette.colors.grey[600]} variant='font12Medium'>
          {t('common.labelWithColon', { label })}
        </Typography>
        &nbsp;
        {value}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        wordBreak: 'break-word',
      }}
    >
      <Typography color={palette.colors.grey[600]} variant='font12Medium'>
        {t('common.labelWithColon', { label })}
      </Typography>
      &nbsp;
      <Typography
        color={
          color ||
          (value === NA ? palette.colors.grey[500] : palette.colors.black)
        }
        variant='font12Medium'
      >
        {/* If loading, show a skeleton, otherwise either show the value or fallback to n/a */}
        {isLoading ? <Skeleton width={30} /> : value}
      </Typography>
    </Box>
  );
};
